import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { NfcCard } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';
dayjs.extend(isBetween);

const isDateIn7Days = (date: dayjs.Dayjs) => dayjs(date).isBetween(dayjs(), dayjs().add(7, 'days'), 'day', '[]');

const isBlockingCardsEnabled = process.env.REACT_APP_IS_BLOCKING_CARDS_ENABLED === 'true';

export const isCardBlockedStatus = (card: NfcCard) =>
  Boolean(isBlockingCardsEnabled && card.assignment && card.assignment.blocked !== null);

export const isCardExpiresSoonStatus = (card: NfcCard) =>
  Boolean(card.assignment?.expiryDate && !card.assignment.expired && isDateIn7Days(dayjs(card.assignment.expiryDate)));

export const isUserDeletedStatus = (card: NfcCard) =>
  Boolean(
    card.assignment?.visitorName && (card.assignment?.visitor === undefined || card.assignment?.visitor === null)
  );

export const isCardExpiredStatus = (card: NfcCard) => Boolean(card.assignment?.expired);

export const isRightsChangedStatus = (card: NfcCard) => Boolean(card.updateRequired);

export const isUserExpiresSoonStatus = (card: NfcCard) =>
  Boolean(card.assignment?.visitor?.expirationDate && isDateIn7Days(dayjs(card.assignment.visitor.expirationDate)));

export const isCardValidityExpiresIn = (card: NfcCard, value: number, unit?: dayjs.ManipulateType) =>
  Boolean(
    card.assignment?.expiryDate &&
      !card.assignment?.expired &&
      dayjs(card.assignment.expiryDate).isBetween(dayjs(), dayjs().add(value, unit), 'day', '[]')
  );

export const getStatusPriority = (card: NfcCard) => {
  if (isCardBlockedStatus(card)) return 5;
  if (isUserDeletedStatus(card)) return 4;
  if (isCardExpiredStatus(card)) return 3;
  if (isRightsChangedStatus(card)) return 2;
  if (isUserExpiresSoonStatus(card)) return 1;
  if (isCardExpiresSoonStatus(card)) return 0;
  return -1;
};

export const getCardStatusesArray = (card: NfcCard, translation: Translation) => [
  ...(isCardBlockedStatus(card) ? [translation.blocked] : []),
  ...(isCardExpiresSoonStatus(card) ? [translation.card_expires_soon] : []),
  ...(isUserDeletedStatus(card) ? [translation.user_deleted] : []),
  ...(isCardExpiredStatus(card) ? [translation.card_expired] : []),
  ...(isRightsChangedStatus(card) ? [translation.rights_changed] : []),
  ...(isUserExpiresSoonStatus(card) ? [translation.user_expires_soon] : [])
];

export const getActionArray = (card: NfcCard, translation: Translation) => [
  ...(isCardExpiresSoonStatus(card) || isCardExpiredStatus(card) || isRightsChangedStatus(card)
    ? [translation.update_card]
    : []),
  ...(isUserDeletedStatus(card) ? [translation.wipe_card_or_change_user] : [])
];

export const getCardsByVisitorId = (visitorId: string, cards: NfcCard[]): NfcCard[] =>
  cards.filter((card) => card.assignment?.visitor?.id === visitorId);
